import * as React from "react";
import * as Modal from "react-modal";
import {FormComponentProps} from "../../form/Form";
import {TicketView} from "./TicketView";
import {ItemView} from "../../../../generated/protocol";
import {ItemService, ITEM_SERVICE_NAME} from "../../../service/admin/ItemService";
import {kernel} from "../../../ioc/IOCHelper";

interface LinkTicketModalProps extends FormComponentProps {
    isOpen: boolean,
    onClose: () => {},
    onLink: (TicketEntity) => {}
}

interface LinkTicketModalState {
    tickets: ItemView[],
    loading: boolean
}

export class LinkTicketModal extends React.Component<LinkTicketModalProps, LinkTicketModalState> {
    static LinkTicketModalStyle = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)'
        }
    };

    itemService: ItemService;

    constructor() {
        super();
        this.itemService = kernel.get<ItemService>(ITEM_SERVICE_NAME);
        this.state = {
            loading: true,
            tickets: []
        };
    }

    componentDidMount() {
        this.itemService.listByCategory("TICKET").then((reply: any) => this.setState({
            loading: false,
            tickets: reply.items
        }));
    }

    onLink(anItemView: ItemView) {
        this.props.onLink(anItemView);
        this.props.onClose();
    }

    renderTickets() {
        if (this.state.loading) {
            return (<div className="no-tickets">... loading ...</div>);
        }
        else {
            var tickets: any[] = this.state.tickets;
            if (tickets.length == 0) {
                return (<div className="no-tickets">no tickets</div>);
            }
            else {
                return (<div>
                    {tickets.map(ticket => <TicketView buttonClass={"link-button"} key={ticket.nameId} entity={ticket}
                                                       onClick={this.onLink.bind(this)}/>)}
                </div>);
            }
        }
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                style={LinkTicketModal.LinkTicketModalStyle}
                contentLabel="All Existing Tickets"
            >
                <div className="link-ticket-modal">
                    <div className="title">Link Existing Ticket</div>
                    <div className="col-sm-10 tickets">
                        {this.renderTickets()}
                    </div>
                    <button className="close-button" onClick={(event) => {
                        event.preventDefault();
                        this.props.onClose();
                    }}><i className="fa  fa-window-close-o"/></button>
                    <div className="bottom"/>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/LinkTicketModal.tsx